<template>
  <b-form @submit="onSubmit">
    <b-col lg="4" class="col-content">
        <b-form-group id="nameGroup">
        <h2 class="inputHeader">{{ $t('privatePage.expert_report_name_header') }}</h2>
        <b-form-input type="text" v-model="currentReport.name" required/>
      </b-form-group>
      <b-form-group id="testMethodGroup">
        <h2 class="inputHeader">{{ $t('privatePage.testmethod_header') }}</h2>
        <b-form-select id="testMethodInput"
                      :options="reportOptions.testMethods"
                      v-model="currentReport.testMethodId"
                      value-field="id"
                      text-field="name"
                      required>
        </b-form-select>
      </b-form-group>
      <b-form-group id="credits">
        <h2 class="inputHeader">{{ $t('privatePage.creditCost_header') }}</h2>
        <b-form-input id="creditsInput"
                      type="number"
                      v-model="currentReport.creditCost"
                      required>
        </b-form-input>
        <template slot="invalid-feedback">
          {{$t('credits_error_feedback')}}
        </template>
      </b-form-group>
      <b-form-group id="languageGroup">
        <h2 class="inputHeader">{{ $t('privatePage.language') }}</h2>
        <EasyDataTable
          :headers="languageTableFields"
          :items="languages"
          :alternating="true"
          :rows-per-page="10000"
          :hide-rows-per-page="true"
        >
          <template #item-countryCode="item">
            <span :class="'me-1 flagItem flag-icon flag-icon-' + item.countryCode"></span>
            <span >{{item.langName}}</span>
          </template>
          <template #item-buttons="item">
            <div v-if="!translationSelected(item.languageId)">
              <b-button @click.stop="onAddTranslation(item.languageId)"
                        size="sm"
                        class="fa fa-plus">
              </b-button>
            </div>
            <div v-else>
              <b-button @click.stop="onDeleteTranslation(item.languageId)"
                        size="sm"
                        class="fa fa-trash"
                        variant="danger">
              </b-button>
            </div>
          </template>
        </EasyDataTable>
      </b-form-group>
      <b-form-group>
        <b-button type="submit" class="me-1">{{ $t('save') }}</b-button>
        <b-button type="button" variant="danger" @click.stop="onDeleteReport">{{ $t('delete') }}</b-button>
      </b-form-group>
    </b-col>
  </b-form>
</template>

<script>
export default {
  name: 'expert-report-details-editor',
  props: {
    currentReport: {},
    languages: {},
    reportOptions: {}
  },
  computed: {
    languageTableFields() {
      return [
        { value: 'countryCode', text: '' },
        { value: 'name', text: ' ' },
        { value: 'buttons', text: ' ', tdClass: 'rightAlignedField' }
      ]
    },
    hasTranslations() {
      let noOfLanguages = 0
      let hasTranslations =
        this.currentReport &&
        this.currentReport.translations &&
        this.currentReport.translations.length > 0

      if (!hasTranslations) return false

      this.currentReport.translations.forEach(translation => {
        if (translation.languageId) noOfLanguages++
      })
      return noOfLanguages > 0 && hasTranslations
    }
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()
      this.$emit('onSubmit')
    },
    onDeleteReport: function() {
      this.$emit('onDeleteReport')
    },
    onAddTranslation: function(languageId) {
      this.$emit('onAddTranslation', languageId)
    },
    onDeleteTranslation: function(languageId) {
      let translation = this.getTranslation(languageId)
      this.$emit('onDeleteTranslation', translation)
    },
    onTestMethodSelected() {
      this.$emit('onTestMethodSelected')
    },
    getTranslation(languageId) {
      var translation = null

      if (!this.hasTranslations) {
        return null
      }

      for (let i = 0; i < this.currentReport.translations.length; i++) {
        var item = this.currentReport.translations[i]
        if (item.languageId === languageId) {
          translation = item
          break
        }
      }

      return translation
    },
    translationSelected(languageId) {
      return this.getTranslation(languageId) !== null
    }
  }
}
</script>
